import { useRef } from "react";
import { Button } from "./Button";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from "./ui/dialog";

export function RestartDialog({ open, onCancel, onConfirm }: { open: boolean; onCancel: () => void; onConfirm: () => void }) {
  const previousFocus = useRef<HTMLElement | null>(null);
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onCancel(); }}>
      <DialogContent role="alertdialog" onOpenAutoFocus={(event) => {
        event.preventDefault();
        previousFocus.current = document.activeElement as HTMLElement | null;
        document.getElementById("restart-cancel")?.focus();
      }} onCloseAutoFocus={(event) => {
        event.preventDefault();
        previousFocus.current?.focus();
        previousFocus.current = null;
      }}>
        <DialogTitle id="restart-title">Start again?</DialogTitle>
        <DialogDescription id="restart-description">This will clear your six answers and any snapshot you have generated.</DialogDescription>
        <div className="button-row">
          <DialogClose asChild><Button id="restart-cancel" variant="secondary">Cancel</Button></DialogClose>
          <Button variant="danger" onClick={onConfirm}>Clear and start again</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
